<template>
  <div class="searchResultHeader mtp-1 mbm-1">
    {{ headerName }}
  </div>
</template>

<script>
export default {
  name: 'SearchResultHeader',
  props: {
    headerName: String
  }
}
</script>

<style scoped lang="scss">
.searchResultHeader {
  font-size: 14px;
  font-weight: 700;
  color: rgb(50, 102, 222);
  position: relative;
  width: 100%;
  height: 38px;
  padding-bottom: 5px;
  border-bottom: 1px solid rgb(50, 102, 222);
}
.searchResultHeader:before {
  position: absolute;
  top: 8px;
  left: 49.31%;
  content: '';
  width: 0;
  height: 0;
  border-style: dashed dashed solid dashed;
  border-width: 10px 10px 20px 10px;
  border-color: transparent transparent rgb(50, 102, 222) transparent;
}
.searchResultHeader:after {
  position: absolute;
  top: 10px;
  left: 49.31%;
  content: '';
  width: 0;
  height: 0;
  border: 2px;
  border-style: dashed dashed solid dashed;
  border-width: 10px 10px 20px 10px;
  border-color: transparent transparent #fff transparent;
}
</style>
